import React from 'react';
import DataTable from '../../../Common/DataTable';
import { Edit } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { H5 } from '../../../../AbstractElements';
import { formatDateTR } from '../../../../_helper/formatters';
import { actionButtonColumn } from '../../../Common/TableColumns';

const AccidentFileInfo = ({ accidentFiles = [], onSelectedRowsChange, isLoading = false }) => {
    const navigate = useNavigate();

    const handleCallForm = (row) => {
        const callFormId = row.callForm?.[0];

        if (callFormId) {
            navigate(`/callform/${callFormId}`);
        } else {
            console.warn("Call form ID not found or structure unexpected in row:", row);
        }
    };

    const handleArbitration = (row) => {
        const arbitrationId = Array.isArray(row.arbitration) && row.arbitration.length > 0 ? row.arbitration[0] : null;

        if (arbitrationId) {
            navigate(`/arbitration/${arbitrationId}`);
        } else {
            console.warn("Arbitration ID not found or structure unexpected in row:", row);
        }
    };

    const columns = [
        { name: 'Dosya Numarası', selector: row => row.fileNumber || '', sortable: true },
        { name: 'Esas Numarası', selector: row => row.caseNumber || row.docketNumber || '', sortable: true },
        { name: 'Plaka', selector: row => row.accident?.licensePlate?.licensePlateNumber || '', sortable: true },
        { name: 'Kaza Tarihi', selector: row => formatDateTR(row.accident?.accidentDate), sortable: true },
        {
            name: 'Açık / Kapalı',
            selector: row => {
                if (typeof row.fileIsClosed === 'boolean') {
                    return row.fileIsClosed ? 'Kapalı' : 'Açık';
                }
                return row.fileStatus || '';
            },
            sortable: true,
        },
        {
            name: 'Dosya Türü',
            selector: row => {
                if (!Array.isArray(row.filesToBeWorked)) return '';
                const titles = row.filesToBeWorked
                    .map(item => {
                        if (Array.isArray(item.fileType) && item.fileType.length > 0) {
                            return item.fileType.map(ft => ft.title).filter(Boolean).join(', ');
                        }
                        return item.fileType?.title || '';
                    })
                    .filter(Boolean);
                return titles.join(', ');
            },
            sortable: true,
        },
        actionButtonColumn({
            name: 'Tahkim',
            icon: Edit,
            onClick: handleArbitration,
            isVisible: (row) => Array.isArray(row.arbitration) && row.arbitration.length > 0,
            className: 'btn btn-outline-info'
        }),
        actionButtonColumn({
            name: 'Çağrı Formu',
            icon: Edit,
            onClick: handleCallForm,
            className: 'btn btn-outline-warning'
        }),
    ];

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <H5>Kaza Dosyaları</H5>
                <div style={{ height: '38px' }} aria-hidden="true" />
            </div>
            <div style={{ minHeight: '200px' }}>
                <DataTable
                    columns={columns}
                    data={accidentFiles}
                    pagination
                    paginationPerPage={10}
                    sortable
                    stickyActionPosition="left"
                    onSelectedRowsChange={onSelectedRowsChange}
                    clearSelectedRows={false}
                    progressPending={isLoading}
                    progressComponent={<div className="py-4 text-center">Yükleniyor...</div>}
                    noDataComponent={isLoading ? null : (
                        <div className="w-100 text-start">Müşteriye ait kaza dosyası bulunamadı.</div>
                    )}
                />
            </div>
        </>
    );
};

export default AccidentFileInfo;
